module.exports = __webpack_public_path__ + "static/media/Joker BlackBlack.2b677e48.png";